import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/css';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


window.$ = $;

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

$('header .menu').click(function() {
    $('.mobile-menu').toggleClass('open');

});

$('.element-cogwheel svg, .element-cogwheel .cogwheel-headline').hover(function() {
    //var svg = $(this);
    var rel = $(this).attr('rel');
    $('.element-cogwheel svg .cogwheel-fill').css('fill','#cbcbcb'); // grau
    $('.cogwheel-' + rel + ' .cogwheel-fill').css('fill','#173D96'); // blau

    //$('.cogwheel-text').addClass('d-none');
    //$('.cogwheel-row-' + rel + ' .cogwheel-text').removeClass('d-none');

    $('.cogwheel-row .cogwheel').css('animation','none');
    $('.cogwheel-row-' + rel + ' .cogwheel').css('animation','rotating 5s linear infinite');

});
$('.element-cogwheel').mouseout(function() {
    $($(this) + ' svg').css('opacity','1');
});

// swiper
const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    autoplay: false,
    slidesPerView: 1,
    spaceBetween: 30,
    slidesPerGroupSkip: 2,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // responsive
    breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    }
});

$('.clickable').click(function(){
    let $this = $(this);
    if($this.find("a").length){
        window.location.href = $this.find("a:first").attr("href");
    }
});

$('.button-play').click(function() {
    var el = $(this);
    // get youtubeId
    var videoId = $(el).attr('data-video');
    // find parent elements
    var parent = $(el).parents('.youtube-container').find('.embed-container');
    // set iframe code
    var video = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+videoId+'?rel=0&amp;showinfo=0&amp;autoplay=1&amp;modestbranding=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    // remove images
    $(el).parents('.youtube-container').find('.youtube-preview').remove();
    $(el).parents('.youtube-container').find('.button-play').remove();
    // append iframe to div
    $(parent).append(video);
});